<form (ngSubmit)="onConfirm()">
    <div class="modal-header">
        <div class="modal-title pull-left section-title">
            {{title}}
        </div>
        <button type="button" class="btn-close" (click)="hideConfirmationModal()" aria-label="Close">

        </button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-sm-12">
                <p>{{body}}</p>
            </div>
        </div>

        <div class="row mt-4">
            <div class="col-sm-12 d-flex justify-content-end">
                <button type="submit" class="vid-btn vid-btn-green vid-btn-sm me-1">{{yesLabel | translate}}</button>
                <button type="button" class="vid-btn vid-btn-sm me-1" (click)="onCancel()">{{noLabel | translate}}</button>
            </div>
        </div>

    </div>
</form>
